import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["number"]
  connect() {
    this.io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { this.animateNumbers(); this.io.disconnect() } })
    }, { threshold: 0.5 })
    this.io.observe(this.element)
  }
  disconnect() { this.io?.disconnect() }
  animateNumbers() {
    this.numberTargets.forEach(el => {
      const raw    = el.dataset.target || el.textContent.replace(/[^0-9.,]/g, "")
      const target = parseFloat(raw.replace(",", "."))
      const suffix = el.dataset.suffix || el.textContent.replace(/[0-9.,]/g, "").trim()
      if (isNaN(target)) return
      const duration = 1400
      const start    = performance.now()
      const update   = now => {
        const p    = Math.min((now - start) / duration, 1)
        const ease = 1 - Math.pow(1 - p, 3)
        const val  = target < 100 ? (target * ease).toFixed(1).replace(".", ",") : Math.round(target * ease).toLocaleString("nb-NO")
        el.textContent = val + (suffix ? " " + suffix : "")
        if (p < 1) requestAnimationFrame(update)
      }
      requestAnimationFrame(update)
    })
  }
}
